import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ProrrogaContent } from './components/ProrrogaContent';

export default function Prorroga() {
    return (
        <>
            <MainContent
                component={<ProrrogaContent />}
                titulo='Gestión de Prorrogas'
                noBackground
                tableMaxWidth
                labelBottom={"Los contratos se podrán prorrogar siempre y cuando el cliente tenga parametrizados los requisitos y el estado del presupuesto no este en condicional."}
            />
        </>
    );

};
